// Vue
import {mixins} from 'vue-class-component'
import {Vue, Component, Prop, Inject, Watch} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Icon} from './../../icon/Icon'

// Mixins
import {EventBus} from '../../../../mixins/event_bus/EventBus'

@Component({
    name: 'SelectOption',
    components: {Icon},
    mixins: [
        template,
    ]
})
export class SelectOption extends mixins(EventBus) {

    public get isHidden() {
        return this.searchTerm.length > 0 && this.label.trim().toLowerCase().indexOf(this.searchTerm.trim().toLowerCase()) == -1
    }

    public selected: boolean = false
    public searchTerm: string = ''
    private focused: boolean = false
    private limitDisabled: boolean = false

    @Prop([String, Number, Boolean])
    public value: any

    @Prop([String, Number])
    public label!: any

    @Prop()
    public disabled!: boolean

    @Prop({default: false})
    public disableSelectionOnly!: boolean

    @Inject({ from: 'selectMultiple'})
    public multiple!: boolean

    @Watch('value')
    public watchValue(value, oldValue) {
        this.dispatch('Select', 'registerLabel', [value, this.label])
    }

    @Watch('label')
    public watchLabel(label, oldLabel) {
        this.dispatch('Select', 'registerLabel', [this.value, label])
    }

    @Watch('disableSelectionOnly')
    public watchDisableSelectionOnly(disableSelectionOnly, oldDisableSelectionOnly) {
        this.dispatch('Select', 'registerLabel', [this.value, this.label, this.disabled && !disableSelectionOnly ])
    }

    get finalDisabled() {
        if (this.limitDisabled && !this.selected) {
            return true
        } else {
            return this.disabled
        }
    }

    public created () {

        this.$on('change', this.handleModelChange)
        this.$on('limitDisable', this.handleModelLimitDisable)
        this.$on('focus', this.handleModelFocus)
        this.$on('searchTermChange', this.handleSearchTermChange)
        if ( !this.disabled ) {
            this.dispatch('SelectGroup', 'registerValue', this.value)
        }
        this.dispatch('Select', 'registerLabel', [this.value, this.label, this.disabled && !this.disableSelectionOnly])
    }

    public destroyed() {
        this.$off('change', this.handleModelChange)
        this.$off('focus', this.handleModelFocus)
        this.$off('searchTermChange', this.handleSearchTermChange)
    }

    public handleModelChange(model: any) {

        if (model instanceof Array) {
            this.selected = model.includes(this.value) ? true : false
        } else {
            this.selected = model === this.value
        }
    }

    private handleModelFocus(model: any) {

        this.focused = model === this.value
    }

    public handleSelected() {

        if (this.disabled) return

        this.dispatch('Select', 'change', [this.value])
    }

    private handleModelLimitDisable(disabled: any) {
        this.limitDisabled = disabled;
    }

    public handleSearchTermChange(searchTerm: string) {

        this.searchTerm = searchTerm
    }
}